<mat-card appearance="outlined" class="card">
  <h1 mat-card-title i18n>Edit Branch Data</h1>
  <form [formGroup]="editBranchFormGroup" class="edit-branch-form">
    <div class="edit-branch-form-section">
      <mat-card-subtitle class="app-subtitle-ps" i18n>
        Address Data
      </mat-card-subtitle>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label i18n="@@name">Branch name</mat-label>
        <input matInput formControlName="name" />
        <mat-icon class="material-symbols-outlined" matIconPrefix
          >apartment
        </mat-icon>
      </mat-form-field>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>External Id</mat-label>
        <input matInput formControlName="externalId" />
        <mat-icon class="material-symbols-outlined" matIconPrefix
          >present_to_all
        </mat-icon>
      </mat-form-field>
      <mat-form-field subscriptSizing="dynamic">
        <mat-label>Branch full name</mat-label>
        <input matInput formControlName="fullname" />
        <mat-icon class="material-symbols-outlined" matIconPrefix
          >apartment
        </mat-icon>
      </mat-form-field>
      <div class="flex-row flex-wrap gap-9">
        <mat-form-field class="zip-code-form" subscriptSizing="dynamic">
          <mat-label i18n="@@zip">Postal</mat-label>
          <input matInput formControlName="postal" />
          <mat-icon class="material-symbols-outlined" matIconPrefix
            >email
          </mat-icon>
        </mat-form-field>
        <mat-form-field class="flex-grow" subscriptSizing="dynamic">
          <mat-label i18n="@@place">Place</mat-label>
          <input matInput formControlName="city" />
          <mat-icon class="material-symbols-outlined" matIconPrefix
            >local_post_office
          </mat-icon>
        </mat-form-field>
        <mat-form-field class="flex-grow" subscriptSizing="dynamic">
          <mat-label i18n="@@address">Address</mat-label>
          <input matInput formControlName="address" />
          <mat-icon class="material-symbols-outlined" matIconPrefix
            >home
          </mat-icon>
        </mat-form-field>
      </div>
      <mat-divider />

      <mat-divider />
      <mat-card-subtitle class="app-subtitle-ps" i18n="@@contactPerson">
        Contact Person
      </mat-card-subtitle>
      <div class="flex-row flex-wrap gap-9">
        <mat-form-field class="flex-grow" subscriptSizing="dynamic">
          <mat-label i18n="@@conatctPerson">Contact Person</mat-label>
          <input matInput formControlName="contact" />
          <mat-icon class="material-symbols-outlined" matIconPrefix
            >person
          </mat-icon>
        </mat-form-field>
        <mat-form-field class="flex-grow" subscriptSizing="dynamic">
          <mat-label i18n="@@contactEmail">e-mail</mat-label>
          <input matInput formControlName="email" />
          <mat-icon class="material-symbols-outlined" matIconPrefix
            >email
          </mat-icon>
        </mat-form-field>
        <mat-form-field class="flex-grow" subscriptSizing="dynamic">
          <mat-label i18n="@@contactPhone">Phone Number</mat-label>
          <input matInput formControlName="phone" />
          <mat-icon class="material-symbols-outlined" matIconPrefix
            >phone
          </mat-icon>
        </mat-form-field>
      </div>
      <div class="flex-row flex-wrap gap-9 actions-btn">
        <button
          class="flex-grow"
          matButton
          (click)="onCloseClick()"
          i18n="@@buttonClose"
        >
          Close
        </button>
        <button
          class="flex-grow"
          matButton
          color="primary"
          (click)="onSave()"
          [disabled]="
            !editBranchFormGroup.valid || !editBranchFormGroup.touched
          "
          i18n="@@buttonSave"
        >
          Save
        </button>
      </div>
    </div>
  </form>
</mat-card>
